module.exports = __webpack_public_path__ + "static/media/courrier_accompagnement_adhesion_GPI_GO_viasante.72dade9d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/common/form/courrier_accompagnement_adhesion_GPI_GO_viasante.pdf
// module id = 313
// module chunks = 40